<!-- ApplicationCard.vue -->
<template>
  <div class="card-wrapper" v-for="application in applications" :key="application.id">
    <div class="applicant-row">
      <div class="image_wrapper" @click="userInfoModalOpen(application)">
        <el-avatar :size="'small'" shape="square" :src="application.image" v-if="application.image" />
        <el-avatar :size="'small'" class="avatar-job" shape="square"
          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
      </div>
      <div class="applicant-info">
        <div class="applicant-name">{{ application.applicantName }}</div>
        <div class="applicant-job-type" :class="application.type">
          {{ application.type }}
        </div>
      </div>
      <el-button class="more-option text-only" @click="openMoreOptionDrawer(application)">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.0002 2.5C9.0835 2.5 8.3335 3.25 8.3335 4.16667C8.3335 5.08333 9.0835 5.83333 10.0002 5.83333C10.9168 5.83333 11.6668 5.08333 11.6668 4.16667C11.6668 3.25 10.9168 2.5 10.0002 2.5ZM10.0002 14.1667C9.0835 14.1667 8.3335 14.9167 8.3335 15.8333C8.3335 16.75 9.0835 17.5 10.0002 17.5C10.9168 17.5 11.6668 16.75 11.6668 15.8333C11.6668 14.9167 10.9168 14.1667 10.0002 14.1667ZM10.0002 8.33333C9.0835 8.33333 8.3335 9.08333 8.3335 10C8.3335 10.9167 9.0835 11.6667 10.0002 11.6667C10.9168 11.6667 11.6668 10.9167 11.6668 10C11.6668 9.08333 10.9168 8.33333 10.0002 8.33333Z"
            fill="rgb(var(--locumate-clr-gray))" />
        </svg>
      </el-button>
    </div>

    <div class="address-row has-federal-support">
      <div class="d-flex align-items-center gap-2 flex-1">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
          <path
            d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
        </svg>
        <div class="address">{{ application.address }}</div>
      </div>
      <div class="d-flex align-items-center gap-2 flex-1" v-if="application.federalPharmacistSupport === 1 && isUS">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.29169 1.66663V18.3333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
            stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M4.29169 3.33337H13.625C15.875 3.33337 16.375 4.58337 14.7917 6.16671L13.7917 7.16671C13.125 7.83337 13.125 8.91671 13.7917 9.50004L14.7917 10.5C16.375 12.0834 15.7917 13.3334 13.625 13.3334H4.29169"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>


        <div class="address" v-if="application.federalPharmacistSupport === 1">Federal Pharmacist Support</div>
      </div>

    </div>

    <div class="rate-row">
      <div class="hourly-rate-row" v-if="application.payInterval == 'Hourly'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.22656 11.9412C7.22656 13.0162 8.05156 13.8829 9.07656 13.8829H11.1682C12.0599 13.8829 12.7849 13.1245 12.7849 12.1912C12.7849 11.1745 12.3432 10.8162 11.6849 10.5829L8.32656 9.41621C7.66823 9.18288 7.22656 8.82454 7.22656 7.80788C7.22656 6.87454 7.95156 6.11621 8.84323 6.11621H10.9349C11.9599 6.11621 12.7849 6.98288 12.7849 8.05788"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <div>
          <div class="row-label">Hourly Rate</div>
          <div class="hourly-rate">{{ application.hourlyRate }}</div>
        </div>
      </div>
      <div class="annual-rate-row" v-if="application.payInterval == 'Annual'">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.22656 11.9412C7.22656 13.0162 8.05156 13.8829 9.07656 13.8829H11.1682C12.0599 13.8829 12.7849 13.1245 12.7849 12.1912C12.7849 11.1745 12.3432 10.8162 11.6849 10.5829L8.32656 9.41621C7.66823 9.18288 7.22656 8.82454 7.22656 7.80788C7.22656 6.87454 7.95156 6.11621 8.84323 6.11621H10.9349C11.9599 6.11621 12.7849 6.98288 12.7849 8.05788"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M10 5V15" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M10.0001 18.3337C14.6025 18.3337 18.3334 14.6027 18.3334 10.0003C18.3334 5.39795 14.6025 1.66699 10.0001 1.66699C5.39771 1.66699 1.66675 5.39795 1.66675 10.0003C1.66675 14.6027 5.39771 18.3337 10.0001 18.3337Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <div>
          <div class="row-label">Annual Rate</div>
          <div class="annual-rate">{{ application.annuallyRate }}</div>
        </div>
      </div>
      <div class="duration-row half">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.6666 18.3333H13.3333C16.6833 18.3333 17.2833 16.9917 17.4583 15.3583L18.0833 8.69167C18.3083 6.65833 17.7249 5 14.1666 5H5.83327C2.27494 5 1.6916 6.65833 1.9166 8.69167L2.5416 15.3583C2.7166 16.9917 3.3166 18.3333 6.6666 18.3333Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M6.66675 5.00033V4.33366C6.66675 2.85866 6.66675 1.66699 9.33341 1.66699H10.6667C13.3334 1.66699 13.3334 2.85866 13.3334 4.33366V5.00033"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M11.6666 10.8333V11.6667C11.6666 11.675 11.6666 11.675 11.6666 11.6833C11.6666 12.5917 11.6583 13.3333 9.99992 13.3333C8.34992 13.3333 8.33325 12.6 8.33325 11.6917V10.8333C8.33325 10 8.33325 10 9.16659 10H10.8333C11.6666 10 11.6666 10 11.6666 10.8333Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M18.0417 9.16699C16.1167 10.567 13.9167 11.4003 11.6667 11.6837"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M2.18335 9.3916C4.05835 10.6749 6.17502 11.4499 8.33335 11.6916"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <div>
          <div class="row-label">Experience</div>
          <div class="duration">{{ application.experience }}</div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="duration-row half question" v-if="application.questions?.length"
        @click="displayQuestions(application.questions)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M22 12.86C22 15.15 20.82 17.1801 19 18.4601L17.66 21.41C17.35 22.08 16.45 22.2101 15.98 21.6401L14.5 19.86C12.08 19.86 9.92001 18.7901 8.57001 17.1201L9.5 16.0001C13.64 16.0001 17 12.8701 17 9.00006C17 7.95006 16.75 6.96007 16.3 6.07007C19.57 6.82007 22 9.58005 22 12.86Z"
            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M7 9H12" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <div>
          <div class="row-label">Questionnaires</div>
          <div class="display-question">View</div>
        </div>
      </div>
    </div>

    <div class="d-flex applied-date-row">
      <div class="row-label">
        Applied <span>{{ application.applied }}</span>
      </div>
    </div>

    <div class="badge-wrapper">
      <div class="badge-pharmacy" :class="getClass(application.application_tag_status)"
        v-if="application.application_tag_status != ''">
        {{ application.application_tag_status }}
      </div>
    </div>

    <el-checkbox-group v-model="selectedApplications">
      <!-- Iterate over applications and bind each checkbox to its application ID -->
      <el-checkbox :key="application.id" :label="application" class="select-checkmark">
        {{ application.name }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
  <el-drawer custom-class="bottom_drop_up applicant-more-menu select-options-applicant" v-model="displayQuestionsDrawer"
    :append-to-body="true" :with-header="true" :direction="'btt'" :destroy-on-close="true" :show-close="true">
    <div class="auth-header">
      <div class="auth-heading">
        <h1>Question & Answer</h1>
      </div>
    </div>
    <div class="qa-list">
      <div v-for="question in allQuestions" :key="question.id">
        <p class="question">
          {{ question.question }}
        </p>

        <p v-if="question.type !== 'file'" class="answer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.4301 5.92993L20.5001 11.9999L14.4301 18.0699" stroke="rgb(var(--locumate-primary-color-dark))"
              stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.5 12H20.33" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"
              stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ question.answer }}
        </p>
        <div v-else>
          <button @click="viewFile(question.fileUrl)" class="view-file-button">
            View File
          </button>
        </div>
      </div>
    </div>
  </el-drawer>

  <el-drawer custom-class="bottom_drop_up applicant-more-menu select-options-applicant" v-model="bottomDropUpOptions"
    :append-to-body="true" :with-header="true" :direction="'btt'" :destroy-on-close="true" :show-close="true">
    <div class="auth-header">
      <div class="auth-heading">
        <h1>Select option</h1>
      </div>
    </div>

    <el-button class="categorize text-only" size="sm" data-testid="directions-2" @click="openTriageDrawer()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.6699 2H16.7699C14.5899 2 13.4399 3.15 13.4399 5.33V7.23C13.4399 9.41 14.5899 10.56 16.7699 10.56H18.6699C20.8499 10.56 21.9999 9.41 21.9999 7.23V5.33C21.9999 3.15 20.8499 2 18.6699 2Z"
          fill="black" />
        <path
          d="M7.24 13.4297H5.34C3.15 13.4297 2 14.5797 2 16.7597V18.6597C2 20.8497 3.15 21.9997 5.33 21.9997H7.23C9.41 21.9997 10.56 20.8497 10.56 18.6697V16.7697C10.57 14.5797 9.42 13.4297 7.24 13.4297Z"
          fill="black" />
        <path
          d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
          fill="black" />
        <path
          d="M17.7099 21.9999C20.0792 21.9999 21.9999 20.0792 21.9999 17.7099C21.9999 15.3406 20.0792 13.4199 17.7099 13.4199C15.3406 13.4199 13.4199 15.3406 13.4199 17.7099C13.4199 20.0792 15.3406 21.9999 17.7099 21.9999Z"
          fill="black" />
      </svg>

      {{ message.Categorize }}</el-button>
    <el-button class="notify-applicant text-only" :disabled="singleSelectedApplicant?.application_tag_status === ''"
      size="sm" data-testid="directions-2" @click="showSingleNotifyApplicantDrawer(singleSelectedApplicant)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.1902 14.0598L19.0602 12.1798C18.8102 11.7698 18.5902 10.9798 18.5902 10.4998V8.6298C18.5902 4.9998 15.6402 2.0498 12.0202 2.0498C8.3902 2.0598 5.4402 4.9998 5.4402 8.6298V10.4898C5.4402 10.9698 5.2202 11.7598 4.9802 12.1698L3.8502 14.0498C3.4202 14.7798 3.3202 15.6098 3.5902 16.3298C3.8602 17.0598 4.4702 17.6398 5.2702 17.8998C6.3502 18.2598 7.4402 18.5198 8.5502 18.7098C8.6602 18.7298 8.7702 18.7398 8.8802 18.7598C9.0202 18.7798 9.1702 18.7998 9.3202 18.8198C9.5802 18.8598 9.8402 18.8898 10.1102 18.9098C10.7402 18.9698 11.3802 18.9998 12.0202 18.9998C12.6502 18.9998 13.2802 18.9698 13.9002 18.9098C14.1302 18.8898 14.3602 18.8698 14.5802 18.8398C14.7602 18.8198 14.9402 18.7998 15.1202 18.7698C15.2302 18.7598 15.3402 18.7398 15.4502 18.7198C16.5702 18.5398 17.6802 18.2598 18.7602 17.8998C19.5302 17.6398 20.1202 17.0598 20.4002 16.3198C20.6802 15.5698 20.6002 14.7498 20.1902 14.0598ZM12.7502 9.9998C12.7502 10.4198 12.4102 10.7598 11.9902 10.7598C11.5702 10.7598 11.2302 10.4198 11.2302 9.9998V6.89981C11.2302 6.4798 11.5702 6.1398 11.9902 6.1398C12.4102 6.1398 12.7502 6.4798 12.7502 6.89981V9.9998Z"
          fill="black" />
        <path
          d="M14.8302 20.01C14.4102 21.17 13.3002 22 12.0002 22C11.2102 22 10.4302 21.68 9.88018 21.11C9.56018 20.81 9.32018 20.41 9.18018 20C9.31018 20.02 9.44018 20.03 9.58018 20.05C9.81018 20.08 10.0502 20.11 10.2902 20.13C10.8602 20.18 11.4402 20.21 12.0202 20.21C12.5902 20.21 13.1602 20.18 13.7202 20.13C13.9302 20.11 14.1402 20.1 14.3402 20.07C14.5002 20.05 14.6602 20.03 14.8302 20.01Z"
          fill="black" />
      </svg>
      Notify Applicant(s)</el-button>
    <el-button class="view-details text-only" size="sm" data-testid="directions-2"
      @click="userInfoModalOpen(singleSelectedApplicant)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.8002 2.21048C15.3902 1.80048 14.6802 2.08048 14.6802 2.65048V6.14048C14.6802 7.60048 15.9202 8.81048 17.4302 8.81048C18.3802 8.82048 19.7002 8.82048 20.8302 8.82048C21.4002 8.82048 21.7002 8.15048 21.3002 7.75048C19.8602 6.30048 17.2802 3.69048 15.8002 2.21048Z"
          fill="black" />
        <path
          d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.5 17.75H7.5C7.09 17.75 6.75 17.41 6.75 17C6.75 16.59 7.09 16.25 7.5 16.25H11.5C11.91 16.25 12.25 16.59 12.25 17C12.25 17.41 11.91 17.75 11.5 17.75ZM13.5 13.75H7.5C7.09 13.75 6.75 13.41 6.75 13C6.75 12.59 7.09 12.25 7.5 12.25H13.5C13.91 12.25 14.25 12.59 14.25 13C14.25 13.41 13.91 13.75 13.5 13.75Z"
          fill="black" />
      </svg>
      View details</el-button>
  </el-drawer>

  <!-- Conditional rendering for floating buttons -->
  <div class="floating-buttons-wrapper">
    <div v-if="selectedApplications.length > 0" class="floating-buttons">
      <div class="floating-header">
        <span class="select-count">{{ selectedApplications.length }}
          {{ selectedApplications.length > 1 ? "Applicants" : "Applicant" }}
          Selected</span>
        <el-button class="floating-clear text-only" @click="handleCancelation">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM15.36 14.3C15.65 14.59 15.65 15.07 15.36 15.36C15.21 15.51 15.02 15.58 14.83 15.58C14.64 15.58 14.45 15.51 14.3 15.36L12 13.06L9.7 15.36C9.55 15.51 9.36 15.58 9.17 15.58C8.98 15.58 8.79 15.51 8.64 15.36C8.35 15.07 8.35 14.59 8.64 14.3L10.94 12L8.64 9.7C8.35 9.41 8.35 8.93 8.64 8.64C8.93 8.35 9.41 8.35 9.7 8.64L12 10.94L14.3 8.64C14.59 8.35 15.07 8.35 15.36 8.64C15.65 8.93 15.65 9.41 15.36 9.7L13.06 12L15.36 14.3Z"
              fill="black" />
          </svg>
        </el-button>
      </div>
      <!-- Categorize button -->
      <div class="button-group row">
        <el-button class="categorize" size="sm" @click="openBulkTriageDrawer(selectedApplications)">
          {{ message.Categorize }}
        </el-button>
        <!-- Notify Applicant button -->
        <el-button class="notify-applicant" size="sm" @click="showMultiNotifyApplicantDrawer">
          Notify Applicant(s)
        </el-button>
      </div>
    </div>
  </div>

  <el-drawer custom-class="bottom_drop_up select-options-applicant" v-model="bottomDropUp" :append-to-body="true"
    :with-header="false" :direction="'btt'" :destroy-on-close="true">
    <div class="category-select-radio-group">
      <!-- <div class="label-text">Select</div> -->
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Select option</h1>
        </div>
      </div>
      <button class="icon-button close-button" @click="bottomDropUp = false">
        <CloseButtonIcon />
      </button>
      <el-radio-group v-model="selectedCategory" @change="handleRadioChange">
        <el-radio :label="category.jobApplicantCategory" v-for="category in applicantCategories" :key="category.id">{{
          category.jobApplicantCategory }}</el-radio>
      </el-radio-group>
    </div>
  </el-drawer>

  <el-drawer custom-class="bottom_drop_up select-options-applicant" v-model="bottomPopupCategorize"
    :append-to-body="true" :with-header="false" :direction="'btt'" :destroy-on-close="true">
    <div class="category-select-radio-group">
      <!-- <div class="label-text">Select</div> -->
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Select option</h1>
        </div>
      </div>
      <button class="icon-button close-button" @click="bottomPopupCategorize = false">
        <CloseButtonIcon />
      </button>
      <el-radio-group v-model="selectedCategory" @change="handlePopUpRadioChange">
        <el-radio :label="category.jobApplicantCategory" v-for="category in applicantCategories" :key="category.id">{{
          category.jobApplicantCategory }}</el-radio>
      </el-radio-group>
    </div>
  </el-drawer>

  <el-drawer custom-class="bottom_drop_up select-options-applicant" v-model="bottomupBulkCategorize"
    :append-to-body="true" :with-header="true" :direction="'btt'" :destroy-on-close="true" :show-close="true">
    <div class="category-select-radio-group">
      <!-- <div class="label-text">Select option for bulk categorization</div> -->
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Select option</h1>
        </div>
      </div>

      <el-radio-group v-model="selectedCategory" @change="handleBulkPopUpRadioChange">
        <el-radio :label="category.jobApplicantCategory" v-for="category in applicantCategories" :key="category.id">{{
          category.jobApplicantCategory }}</el-radio>
      </el-radio-group>
    </div>
  </el-drawer>
  <modal-user-info :modalName="'userInfoModal'" :options="userInfoModal"
    :selectedCategoryFromParent="selectedCategory"></modal-user-info>

  <el-dialog title="CV Preview" v-model="modalVisible" width="50%" :close-on-click-modal="true" @close="closeCvModal">
    <vue-pdf-embed :source="selectedCv.url" />
  </el-dialog>

  <!-- Notify applicants drawer for multiple checked job applicants -->
  <el-drawer :direction="'btt'" title="Notify Applicant(s)" custom-class="notify-applicant" v-model="showDialog"
    :destroy-on-close="true" @close="handleCancelation">
    <p v-if="selectedApplications.length == 1">
      Are you sure you want to send notification to
      {{ selectedApplications[0].applicantName }}?
    </p>
    <p v-else>
      Are you sure you want to send notification to the selected applicants?
    </p>
    <div class="selected-ids">
      <div v-for="(application, index) in selectedApplications" :key="application.id" class="id-button">
        <div v-touch:swipe.left="() => onSwipeLeft(application, index)"
          v-touch:swipe.right="() => onSwipeRight(application, index)" :class="{ swipedLeft: showActions[index] }">
          <div class="card-wrapper inside-notify" :class="
              application.application_tag_status !== ''
                ? 'categorized'
                : 'uncategorized'
            ">
            <div class="applicant-row">
              <div class="image_wrapper" @click="userInfoModalOpen(application)">
                <el-avatar :size="'small'" shape="square" :src="application.image" v-if="application.image" />
                <el-avatar :size="'small'" class="avatar-job" shape="square"
                  icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
              </div>
              <div class="applicant-info">
                <div class="applicant-name">
                  {{ application.applicantName }}
                </div>
                <div class="applicant-job-type" :class="application.type">
                  {{ application.type }}
                </div>
              </div>
            </div>

            <div class="address-row">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
                <path
                  d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
                  stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
              </svg>
              <div class="address">{{ application.address }}</div>
            </div>

            <div v-if="application.application_tag_status === ''" class="uncategorized-notification">
              <span class="text-danger">Notification will not be sent until the applicant is
                {{ message.Categorized?.toLowerCase() }}.</span>
              <el-button class="danger" @click="openPopupTriageDrawer(application)"
                :class="{ categorize: isSelected(application) }">{{ message.Categorize }}</el-button>
            </div>

            <div class="badge-wrapper">
              <div class="badge-pharmacy" :class="getClass(application.application_tag_status)"
                v-if="application.application_tag_status != ''">
                {{ application.application_tag_status }}
              </div>
            </div>
          </div>
        </div>

        <div class="actions" v-show="showActions[index]"></div>
        <button @click="toggleSelectedApplication(application)" class="delete-btn" v-show="showActions[index]">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
              fill="white" />
            <path
              d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
              fill="white" />
          </svg>
        </button>
      </div>
    </div>
    <div class="notify-note-margin">
      <p class="text-info">
        <small>
          Note: If you have selected one or more applicants from various
          categories, ensure you first choose the respective tab for the
          category, then proceed to fill in the notification template.
        </small>
      </p>
    </div>
    <el-form class="full_page" :model="multiNotifyForm" ref="multiNotifyFormRef" label-position="top">
      <div class="notification-templates mb-3">
        <el-collapse accordion>
          <template v-for="(category, index) in applicantCategories" :key="index">
            <el-collapse-item :title="category.jobApplicantCategory" :name="index">
              <el-form-item class="no-scroll mt-1 mb-0" :prop="category.jobApplicantCategory">
                <div class="OneLinkNoTx">
                  <QuillEditor style="min-height: 300px" v-model:content="
                      multiNotifyForm[category.jobApplicantCategory]
                    " contentType="html" theme="snow" :toolbar="notifyEditorToolbar"
                    @blur="multiValidateField(category.jobApplicantCategory)" @editorChange="
                      multiValidateField(category.jobApplicantCategory)
                    " @input="multiValidateField(category.jobApplicantCategory)" />
                </div>
                <el-form-item-error v-if="multiV$[category.jobApplicantCategory].$error">{{
                  multiV$[category.jobApplicantCategory].$errors[0].$message
                  }}</el-form-item-error>
              </el-form-item>
            </el-collapse-item>
          </template>
        </el-collapse>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer flex-row gap-4">
      <el-button class="secondary mt-0" @click="hideMultiNotifyApplicantDrawer">Cancel</el-button>
      <el-button class="mt-0" type="primary" @click="multiNotifyConfirm">Confirm</el-button>
    </div>
  </el-drawer>
  <el-dialog title="Preview" v-model="modalVisiblePdf" width="50%" :close-on-click-modal="true" @close="closePdfModal">
    <vue-pdf-embed :source="selectedCv.url" />
  </el-dialog>
  <el-dialog title="Preview" v-model="modalVisibleImage" width="50%" :close-on-click-modal="true"
    @close="closeImageModal" class="center-dialog">
    <div class="image-container">
      <img :src="selectedCv.url" alt="preview" />
    </div>
  </el-dialog>
  <!-- Notify applicants drawer for single job applicants -->
  <el-drawer custom-class="bottom_drop_up select-options-applicant" v-model="bottomDropUpNotification"
    :append-to-body="true" :with-header="false" :direction="'btt'" :destroy-on-close="true">
    <div class="category-select-radio-group">
      <div class="auth-header">
        <div class="auth-heading">
          <h1>Notify Applicant(s)</h1>
          <p>
            Are you sure you want to send notification to
            {{ singleSelectedApplicant.applicantName }}?
          </p>
        </div>
      </div>
      <button class="icon-button close-button" @click="hideSingleNotifyApplicationDrawer">
        <CloseButtonIcon />
      </button>
    </div>
    <div class="mt-3">
      <el-form class="full_page" :model="notifyForm" ref="notifyFormRef" label-position="top">
        <el-form-item class="no-scroll" prop="notifyTemplate" label="Notification template">
          <div class="OneLinkNoTx">
            <QuillEditor style="min-height: 300px" v-model:content="notifyForm.notifyTemplate" contentType="html"
              theme="snow" :toolbar="notifyEditorToolbar" @blur="validateField('notifyTemplate')"
              @editorChange="validateField('notifyTemplate')" @input="validateField('notifyTemplate')" />
          </div>
          <el-form-item-error v-if="v$.notifyTemplate.$error">{{
            v$.notifyTemplate.$errors[0].$message
            }}</el-form-item-error>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer flex-row gap-4">
      <el-button class="secondary mt-0" @click="hideSingleNotifyApplicationDrawer">Cancel</el-button>
      <el-button class="mt-0" @click="notifyApplicantConfirm">Notify</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import {
  ref,
  inject,
  getCurrentInstance,
  onMounted,
  onBeforeMount,
  computed,
} from "vue";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import { JobApplicantInfoModal } from "@/modals/modals";
import VuePdfEmbed from "vue-pdf-embed";
import { vTouch } from "vue3-touch-events";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import CloseButtonIcon from "@/components/Icons/CloseButtonIcon.vue";
import {  isUSRegion } from '@/helpers/region/regionHelper.js';


export default {
  props: {
    applications: Object,
  },
  components: {
    "modal-user-info": JobApplicantInfoModal,
    VuePdfEmbed,
    QuillEditor,
    CloseButtonIcon,
  },
  setup(props) {
    console.log("🚀 ~ setupfdfdfdf ~ props:", props)
    const $store = useStore();
    const $router = useRouter();
    const isUS = isUSRegion();

    // const currentRouteName = ref(null);
    const bottomDropUpOptions = ref(false);
    const displayQuestionsDrawer = ref(false);
    const bottomDropUp = ref(false);
    const bottomDropUpNotification = ref(false);
    const bottomPopupCategorize = ref(false);
    const bottomupBulkCategorize = ref(false);
    const applicantCategories = inject("applicantCategories");
    const selectedCategory = ref(null);
    const selectedCv = ref(null);
    const $modals = inject("$modals");
    const showActions = ref([]);
    const allQuestions = ref([]);
    const profileRef = ref(null);
    const notifyTemplates = ref(null);
    const message = inject("messages");
    const modalVisiblePdf = ref(false);
    const modalVisibleImage = ref(false);

    const notifyEditorToolbar = ref([
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }],
      [{ align: [] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
    ]);
    // Array to store selected application IDs
    const selectedApplications = ref([]);
    const singleSelectedApplicant = ref({});
    const userInfoModal = ref({
      name: "userInfo",
      application: {},
    });
    const selectedApplicant = ref(null);

    const notifyForm = ref({
      notifyTemplate: "",
      notifyTemplateType: "",
      applicationId: null,
      applicantName: "",
    });

    const multiNotifyForm = ref({
      Shortlist: "",
      Interview: "",
      Unsuccessful: "",
      Successful: "",
      applicationIds: [],
    });

    // Custom validator for notify template
    const notifyTemplateValidator = (value) => {
      if (
        value.replace(/<(.|\n)*?>/g, "").trim().length === 0 &&
        !value.includes("<img")
      ) {
        return false;
      }
      return true;
    };

    const rules = computed(() => {
      return {
        notifyTemplate: {
          required: helpers.withMessage("Please enter template", required),
          customValidator: helpers.withMessage(
            "Please enter template",
            notifyTemplateValidator
          ),
        },
      };
    });

    const multiNotifyRules = computed(() => {
      return {
        Shortlist: {
          required: helpers.withMessage("Please enter template", required),
          customValidator: helpers.withMessage(
            "Please enter template",
            notifyTemplateValidator
          ),
        },
        Interview: {
          required: helpers.withMessage("Please enter template", required),
          customValidator: helpers.withMessage(
            "Please enter template",
            notifyTemplateValidator
          ),
        },
        Unsuccessful: {
          required: helpers.withMessage("Please enter template", required),
          customValidator: helpers.withMessage(
            "Please enter template",
            notifyTemplateValidator
          ),
        },
        Successful: {
          required: helpers.withMessage("Please enter template", required),
          customValidator: helpers.withMessage(
            "Please enter template",
            notifyTemplateValidator
          ),
        },
      };
    });

    const v$ = useVuelidate(rules, notifyForm);

    const multiV$ = useVuelidate(multiNotifyRules, multiNotifyForm);

    const validateField = (fieldName) => {
      v$.value[fieldName].$touch();
    };

    const multiValidateField = (fieldName) => {
      multiV$.value[fieldName].$touch();
    };

    const showDialog = ref(false);

    const userInfoModalOpen = (application) => {
      if (application) {
        userInfoModal.value.user = application;
      }
      $modals.open("userInfoModal");
    };

    const openMoreOptionDrawer = (application) => {
      singleSelectedApplicant.value = application;
      if (selectedApplications.value.length == 0) {
        selectedCategory.value = application.application_tag_status;
      } else if (
        selectedApplications.value.length > 0 &&
        application.application_tag_status != ""
      ) {
        selectedCategory.value = application.application_tag_status;
      } else if (
        selectedApplications.value.length > 0 &&
        application.application_tag_status == ""
      ) {
        selectedCategory.value = "";
      }

      bottomDropUpOptions.value = true;
    };

    const openTriageDrawer = () => {
      // selectedApplicant.value = application;
      bottomDropUp.value = true;
    };
    const displayQuestions = (question) => {
      // selectedApplicant.value = application;
      allQuestions.value = question;
      console.log("hello questions");
      displayQuestionsDrawer.value = true;
    };

    const openPopupTriageDrawer = (application) => {
      selectedApplicant.value = application;
      bottomPopupCategorize.value = true;
    };

    const openBulkTriageDrawer = () => {
      // selectedApplications.value = applications;
      selectedCategory.value = "";
      bottomupBulkCategorize.value = true;
    };

    const instance = getCurrentInstance();

    const isSelected = (application) => {
      return selectedApplications.value.some(
        (app) => app.id === application.id
      );
    };

    // Method to handle confirmation
    const handleConfirmation = () => {
      // Perform your action here with the selected IDs
      showDialog.value = false; // Hide the dialog
    };

    // Method to handle cancellation
    const handleCancelation = () => {
      showDialog.value = false; // Hide the dialog
      selectedApplications.value = [];
    };

    // Method to toggle selected application IDs
    const toggleSelectedApplication = (application) => {
      const index = selectedApplications.value.findIndex(
        (app) => app.id === application.id
      );
      if (index === -1) {
        // Application not found, add it to the array
        selectedApplications.value.push(application);
      } else {
        // Application found, remove it from the array
        showActions.value = Array(selectedApplications.length).fill(false);
        selectedApplications.value.splice(index, 1);
      }
    };

    const handleBulkPopUpRadioChange = async (selectedStatus) => {
      await ElMessageBox.confirm(
        `Are you sure you want update the status of the applicants?`,
        "Update status",
        {
          confirmButtonText: "Update",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button",
          cancelButtonClass: "el-button secondary",
          showClose: false,
        }
      );

      await (async () => {
        try {
          const ids = selectedApplications.value.map((item) => item.id);
          const applicantStatusCategoriesResponse = await $store.dispatch(
            "UPDATE_BULK_JOB_APPLICANT_STATUS_CATEGORY",
            {
              payload: {
                status: selectedStatus,
                applicationIds: ids,
              },
            }
          );
          updateSelectedApplications(applicantStatusCategoriesResponse.data);

          if (applicantStatusCategoriesResponse.data.success) {
            ElMessage({
              type: "success",
              message: applicantStatusCategoriesResponse.data.message,
            });
            instance.emit("refresh-applicants-list");
          } else {
            ElMessage({
              type: "info",
              message: applicantStatusCategoriesResponse.data.message,
            });
          }

          bottomupBulkCategorize.value = false;
        } catch (error) {
          ElMessage({
            type: "error",
            message: error.status[0],
          });
        }
      })();
    };

    const handlePopUpRadioChange = async (selectedStatus) => {
      await ElMessageBox.confirm(
        `Are you sure you want update the status of the applicant?`,
        "Update status",
        {
          confirmButtonText: "Update",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "secondary",
          showClose: false,
        }
      );

      await (async () => {
        try {
          const applicantStatusCategoriesResponse = await $store.dispatch(
            "UPDATE_JOB_APPLICANT_STATUS_CATEGORY",
            {
              applicationId: selectedApplicant.value.id,
              payload: {
                status: selectedStatus,
              },
            }
          );
          updateSelectedApplications(
            applicantStatusCategoriesResponse.data.data
          );

          if (applicantStatusCategoriesResponse.data.success) {
            ElMessage({
              type: "success",
              message: applicantStatusCategoriesResponse.data.message,
            });
            instance.emit("refresh-applicants-list");
          } else {
            ElMessage({
              type: "info",
              message: applicantStatusCategoriesResponse.data.message,
            });
          }

          bottomPopupCategorize.value = false;
        } catch (error) {
          ElMessage({
            type: "error",
            message: error.status[0],
          });
        }
      })();
    };

    const handleRadioChange = async (selectedStatus) => {
      await ElMessageBox.confirm(
        `Are you sure you want update the status of the applicant?`,
        "Update status",
        {
          confirmButtonText: "Update",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "secondary",
          showClose: false,
        }
      );

      await (async () => {
        try {
          const applicantStatusCategoriesResponse = await $store.dispatch(
            "UPDATE_JOB_APPLICANT_STATUS_CATEGORY",
            {
              applicationId: singleSelectedApplicant.value.id,
              payload: {
                status: selectedStatus,
              },
            }
          );

          if (applicantStatusCategoriesResponse.data.success) {
            ElMessage({
              type: "success",
              message: applicantStatusCategoriesResponse.data.message,
            });

            instance.emit("refresh-applicants-list");
          } else {
            ElMessage({
              type: "info",
              message: applicantStatusCategoriesResponse.data.message,
            });
          }

          bottomDropUp.value = false;
        } catch (error) {
          ElMessage({
            type: "error",
            message: error.status[0],
          });
        }
      })();
    };

    const modalVisible = ref(false);
    // const arrowIconClass = computed(() => {
    //   return props.applications.isDetailsVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
    // });
    const openCvModal = (cv) => {
      // Set the file URL to be displayed in the modal
      selectedCv.value = cv;
      // Show the modal
      modalVisible.value = true;
    };

    const closeCvModal = () => {
      modalVisible.value = false;
    };
    const closePdfModal = () => {
      modalVisiblePdf.value = false;
    };
    const closeImageModal = () => {
      modalVisibleImage.value = false;
    };

    const getClass = (status) => {
      // Convert the status to lowercase for case-insensitive comparison
      const lowercaseStatus = status.toLowerCase();

      // Return class based on status
      return lowercaseStatus;
    };

    const maximizedCardId = ref(null);

    const toggleDetails = (application, event) => {
      // Check if the click event originated from the anchor tag
      if (event.target.tagName.toLowerCase() === "a") {
        return;
      }

      // Close all other application cards except the one that was clicked
      props.applications.forEach((app) => {
        if (app.id !== application.id) {
          app.isDetailsVisible = false;
        }
      });

      // Toggle the visibility of the clicked application card
      application.isDetailsVisible = !application.isDetailsVisible;

      // Update the maximized card ID
      if (application.isDetailsVisible) {
        maximizedCardId.value = application.id;
      } else {
        maximizedCardId.value = null;
      }
    };

    const viewDetails = (application) => {
      $router.push({
        name: "job_applicant_details",
        params: {
          applicationId: application.id,
        },
      });
    };

    const closeOption = (refInfo) => {
      if (refInfo == "profileRef") {
        profileRef.value.blur();
      }
    };

    // Assuming you have a method to update selectedApplications after receiving a Successful response
    const updateSelectedApplications = (updatedApplication) => {
      const index = selectedApplications.value.findIndex(
        (application) => application.id === updatedApplication.id
      );
      if (index !== -1) {
        // Replace the old application data with the updated application data
        selectedApplications.value[index].application_tag_status =
          updatedApplication.applicationTagStatus;

        // Optionally, trigger reactivity update if necessary
        // This depends on your framework's reactivity system
        // For Vue.js with Composition API, no explicit update is needed as long as selectedApplications is a ref
      }
    };

    const onSwipeLeft = (application, index) => {
      showActions.value[index] = true;
      // return function (direction, mouseEvent) {
      //   console.log("Swiped item ", index, ": ", job, " in direction ", direction);
      //   console.log("MouseEvent" , mouseEvent);

      // };
    };

    const onSwipeRight = (application, index) => {
      showActions.value[index] = false;
    };

    // show single application notify drawer
    const showSingleNotifyApplicantDrawer = async (application) => {
      if (application.application_tag_status === "Shortlist") {
        notifyForm.value.notifyTemplate = notifyTemplates.value.shortlist;
        notifyForm.value.notifyTemplateType = "Shortlist";
      } else if (application.application_tag_status === "Interview") {
        notifyForm.value.notifyTemplate = notifyTemplates.value.interview;
        notifyForm.value.notifyTemplateType = "Interview";
      } else if (application.application_tag_status === "Unsuccessful") {
        notifyForm.value.notifyTemplate = notifyTemplates.value.unsuccessful;
        notifyForm.value.notifyTemplateType = "Unsuccessful";
      } else if (application.application_tag_status === "Successful") {
        notifyForm.value.notifyTemplate = notifyTemplates.value.successful;
        notifyForm.value.notifyTemplateType = "Successful";
      }
      notifyForm.value.applicationId = application.id;
      notifyForm.value.applicantName = application.applicantName;
      bottomDropUpNotification.value = true;
    };

    // hide single application notify drawer
    const hideSingleNotifyApplicationDrawer = async () => {
      bottomDropUpNotification.value = false;
      notifyForm.value.notifyTemplate = "";
      notifyForm.value.notifyTemplateType = "";
      notifyForm.value.applicationId = null;
    };

    // confirm notify applicant
    const notifyApplicantConfirm = async () => {
      try {
        await ElMessageBox.confirm(
          `Are you sure you want to send notification to ${notifyForm.value.applicantName}?`,
          "Notify Applicant(s)",
          {
            confirmButtonText: "Notify",
            cancelButtonText: "Cancel",
            confirmButtonClass: "el-button--primary",
            cancelButtonClass: "secondary",
            showClose: false,
          }
        );

        await (async () => {
          try {
            const response = await $store.dispatch("BULK_NOTIFY_SEEKER", {
              applicationIds: [notifyForm.value.applicationId],
              templates: [
                {
                  template: notifyForm.value.notifyTemplate,
                  templateType: notifyForm.value.notifyTemplateType,
                },
              ],
            });

            if (response.success) {
              ElMessage({
                type: "success",
                message: response.message,
              });
              instance.emit("refresh-applicants-list");
            } else {
              ElMessage({
                type: "info",
                message: response.message,
              });
            }
            instance.emit("refresh-applicants-list");
          } catch (error) {
            ElMessage({
              type: "error",
              message: error.message,
            });
          }
        })();
      } catch (error) {
        console.log(error);
      }
    };

    // show multiple applications notify drawer
    const showMultiNotifyApplicantDrawer = () => {
      multiNotifyForm.value.Shortlist = notifyTemplates.value.shortlist;
      multiNotifyForm.value.Interview = notifyTemplates.value.interview;
      multiNotifyForm.value.Unsuccessful = notifyTemplates.value.unsuccessful;
      multiNotifyForm.value.Successful = notifyTemplates.value.successful;
      multiNotifyForm.value.applicationIds = selectedApplications.value.map(
        (item) => item.id
      );

      showDialog.value = true;
    };

    // hide multiple applications notify drawer
    const hideMultiNotifyApplicantDrawer = async () => {
      multiNotifyForm.value.Shortlist = "";
      multiNotifyForm.value.Interview = "";
      multiNotifyForm.value.Unsuccessful = "";
      multiNotifyForm.value.Successful = "";
      multiNotifyForm.value.applicationIds = [];

      selectedApplications.value = [];

      showDialog.value = false;
    };

    // confirm notify multiple applicants
    const multiNotifyConfirm = async () => {
      try {
        let confirmMessage =
          "Are you sure you want to send notification to the selected applicants?";

        if (selectedApplications.value.length === 1) {
          confirmMessage = `Are you sure you want to send notification to ${selectedApplications.value[0].applicantName}?`;
        }
        await ElMessageBox.confirm(confirmMessage, "Notify Applicant(s)", {
          confirmButtonText: "Notify",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "secondary",
          showClose: false,
        });

        await (async () => {
          try {
            const response = await $store.dispatch("BULK_NOTIFY_SEEKER", {
              applicationIds: multiNotifyForm.value.applicationIds,
              templates: [
                {
                  template: multiNotifyForm.value.Shortlist,
                  templateType: "Shortlist",
                },
                {
                  template: multiNotifyForm.value.Interview,
                  templateType: "Interview",
                },
                {
                  template: multiNotifyForm.value.Unsuccessful,
                  templateType: "Unsuccessful",
                },
                {
                  template: multiNotifyForm.value.Successful,
                  templateType: "Successful",
                },
              ],
            });
            if (response.success) {
              ElMessage({
                type: "success",
                message: response.message,
              });
              instance.emit("refresh-applicants-list");
            } else {
              ElMessage({
                type: "info",
                message: response.message,
              });
            }
            instance.emit("refresh-applicants-list");
          } catch (error) {
            ElMessage({
              type: "error",
              message: error.message,
            });
          }
        })();
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      const touchEvents = vTouch({
        swipe: {
          threshold: 15, // Adjust the swipe threshold if needed
        },
      });
      touchEvents.install(); // Install the touch events
    });

    // Method to handle file view
    const viewFile = (fileUrl) => {
      if (!fileUrl) {
        alert("No file available to view.");
        return;
      }

      // Extract the path before the query string
      const cleanUrl = fileUrl.split("?")[0];

      // Extract file extension
      const fileExtension = cleanUrl.split(".").pop().toLowerCase();

      // Check file extension and open accordingly
      if (["pdf"].includes(fileExtension)) {
        // window.open(fileUrl, "_blank");

        selectedCv.value = { url: fileUrl };
        // Show the modal
        modalVisiblePdf.value = true;
      } else if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
        selectedCv.value = { url: fileUrl };
        modalVisibleImage.value = true;
      } else if (fileExtension === "docx") {
        window.open(fileUrl, "_blank");
      } else {
        alert("Unsupported file format.");
      }
    };

    onBeforeMount(async () => {
      $store
        .dispatch("GET_JOB_NOTIFY_TEMPLATES")
        .then((resp) => {
          if (resp.success) {
            notifyTemplates.value = resp.data;
          }
        })
        .catch((err) => {
          console.log("Error fetching notify template", err);
        });
    });

    return {
      showSingleNotifyApplicantDrawer,
      bottomDropUp,
      applicantCategories,
      selectedCategory,
      handleRadioChange,
      userInfoModal,
      userInfoModalOpen,
      getClass,
      selectedCv,
      openCvModal,
      closeCvModal,
      modalVisible,
      // arrowIconClass,
      toggleDetails,
      openMoreOptionDrawer,
      bottomDropUpOptions,
      displayQuestionsDrawer,
      openTriageDrawer,
      viewDetails,
      selectedApplications,
      toggleSelectedApplication,
      showMultiNotifyApplicantDrawer,
      showDialog,
      handleConfirmation,
      handleCancelation,
      isSelected,
      bottomPopupCategorize,
      handlePopUpRadioChange,
      openPopupTriageDrawer,
      updateSelectedApplications,
      bottomupBulkCategorize,
      openBulkTriageDrawer,
      handleBulkPopUpRadioChange,
      onSwipeLeft,
      onSwipeRight,
      showActions,
      singleSelectedApplicant,
      closeOption,
      bottomDropUpNotification,
      notifyTemplates,
      notifyEditorToolbar,
      notifyForm,
      v$,
      validateField,
      notifyApplicantConfirm,
      hideSingleNotifyApplicationDrawer,
      multiNotifyForm,
      multiV$,
      multiValidateField,
      multiNotifyConfirm,
      hideMultiNotifyApplicantDrawer,
      message,
      displayQuestions,
      allQuestions,
      viewFile,
      modalVisiblePdf,
      modalVisibleImage,
      closePdfModal,
      closeImageModal,
      isUS
    };
  },
};
</script>
